export default __webpack_public_path__ + "static/media/Freebooter's Leggings of Pierced Flesh.89594859.jpg";